if (!customElements.get('dentamed-upholstery')) {
  class DentamedUpholstery extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.closest('form');
      if (!this.form) return;
      this.buttons = Array.from(this.querySelectorAll('[data-upholstery-value]'));
      this.select = this.querySelector('[data-upholstery-select]');
      this.selection = this.querySelector('[data-upholstery-selected]');
      if (!this.select) {
        const option = this.form.querySelector(`[data-variant-option-index="${this.dataset.optionIndex}"]`);
        this.nativeOption = option?.closest('fieldset,.options-selection__select-wrapper');
        this.nativeOption?.classList.add('dm-upholstery-native');
      }
      this.onClick = this.choose.bind(this);
      this.onChange = this.sync.bind(this);
      this.onValidate = this.validate.bind(this);
      this.addEventListener('click', this.onClick);
      this.form.addEventListener('change', this.onChange);
      if (this.select) {
        this.classList.add('dm-upholstery--property');
        this.form.addEventListener('submit', this.onValidate, true);
        this.form.addEventListener('click', this.onValidate, true);
        this.form.querySelectorAll('.shopify-payment-button').forEach(button => { button.hidden = true; });
      }
      this.sync();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.nativeOption?.classList.remove('dm-upholstery-native');
      this.form?.removeEventListener('change', this.onChange);
      this.form?.removeEventListener('submit', this.onValidate, true);
      this.form?.removeEventListener('click', this.onValidate, true);
      this.initialized = false;
    }
    fields() {
      return Array.from(this.form.querySelectorAll('[data-variant-option-value-index]')).filter(field => field.dataset.variantOptionValueIndex === this.dataset.optionIndex);
    }
    value() {
      if (this.select) return this.select.value;
      const fields = this.fields();
      const selected = fields.find(field => field.tagName === 'OPTION' ? field.selected : field.checked);
      return selected?.value || '';
    }
    colorAvailable(element) {
      if (!element.dataset.allowedModels) return true;
      const fields = Array.from(this.form.querySelectorAll('[data-variant-option-value-index]'));
      const selected = fields.find(field => field.dataset.variantOptionValueIndex === this.dataset.conditionIndex && (field.tagName === 'OPTION' ? field.selected : field.checked));
      const models = JSON.parse(element.dataset.allowedModels);
      return models.includes(selected?.value);
    }
    choose(event) {
      const button = event.target.closest('[data-upholstery-value]');
      if (!button || !this.contains(button) || button.disabled) return;
      event.stopPropagation();
      const value = button.dataset.upholsteryValue;
      if (this.select) {
        this.select.value = value;
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        const field = this.fields().find(input => input.value === value);
        if (!field) return;
        if (field.tagName === 'OPTION') {
          const select = field.closest('select');
          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          field.click();
        }
      }
      this.sync();
    }
    sync() {
      if (this.select && this.dataset.conditionIndex !== '') {
        Array.from(this.select.options).forEach(option => {
          const available = this.colorAvailable(option);
          option.hidden = !available;
          option.disabled = !available;
        });
        if (this.select.selectedOptions[0]?.disabled) this.select.value = '';
      }
      const value = this.value();
      this.selection.textContent = value;
      const fields = this.select ? [] : this.fields();
      this.buttons.forEach(button => {
        button.checked = button.dataset.upholsteryValue === value;
        const field = fields.find(input => input.value === button.dataset.upholsteryValue);
        const available = this.select ? this.colorAvailable(button) : true;
        button.disabled = this.select ? !available : (!field || field.disabled);
        button.closest('label')?.toggleAttribute('hidden', !available);
      });
    }
    validate(event) {
      if (event.type === 'click' && !event.target.closest('button[type="submit"],input[type="submit"],[data-product-atc]')) return;
      if (this.select && !this.select.value) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.select.reportValidity();
        this.select.focus();
      }
    }
  }
  customElements.define('dentamed-upholstery', DentamedUpholstery);
}


document.addEventListener('change', event => {
  const select = event.target.closest('[data-upholstery-product]');
  if (!select) return;
  const target = new URL(select.value, window.location.origin);
  if (target.origin !== window.location.origin || !target.pathname.startsWith('/products/')) return;
  if (target.pathname !== window.location.pathname) window.location.assign(target.href);
});

(() => {
  const swatches = {"Premium Taupe":{"image":"https://mti.net/wp-content/uploads/2017/08/Taupe-1.png"},"Premium Gunmetal":{"image":"https://mti.net/wp-content/uploads/2017/08/Gunmetal-1.png"},"Premium Mocha":{"image":"https://mti.net/wp-content/uploads/2018/01/mocha-1.png"},"Premium Burgundy":{"image":"https://mti.net/wp-content/uploads/2018/01/Burgandy.png"},"Premium Blue Ridge":{"image":"https://mti.net/wp-content/uploads/2017/08/blue-ridge.jpg"},"Premium Midnight Blue":{"image":"https://mti.net/wp-content/uploads/2018/01/midnight-blue-1.png"},"Premium Dove":{"image":"https://mti.net/wp-content/uploads/2018/01/dove.png"},"Premium Slate":{"image":"https://mti.net/wp-content/uploads/2020/10/Slate_250_HighRes.jpg"},"Premium Black":{"image":"https://mti.net/wp-content/uploads/2017/08/black.jpg"},"Ultra Silver Pearl":{"hex":"#c4cdcd"},"Ultra Ice":{"hex":"#e9ecef"},"Ultra High Seas":{"hex":"#4d606f"},"Ultra Ermine":{"hex":"#fcfdf1"},"Ultra Arctic":{"hex":"#b9b6a9"},"Ultra Classic Grey":{"hex":"#bfbeb9"},"Ultra Schooner":{"hex":"#4f5451"},"Ultra Pelican":{"hex":"#a4a295"},"Ultra Moth Wing":{"hex":"#6f6d5a"},"Ultra Stone":{"hex":"#857f74"},"Ultra Charcoal":{"hex":"#3e444a"},"Ultra Cocoa Nib":{"hex":"#453f33"},"Ultra Dove Grey":{"hex":"#98a2a1"},"Ultra Raven Wing":{"hex":"#353632"},"Ultra Flagstone":{"hex":"#4f5558"},"Ultra Granite":{"hex":"#7b8083"},"Ultra Fudge":{"hex":"#44413d"},"Ultra Papyrus":{"hex":"#8d8568"},"Ultra Doe":{"hex":"#beb8a6"},"Ultra White":{"hex":"#fafaf9"},"Ultra Elephant":{"hex":"#7a8080"},"Ultra Tan":{"hex":"#aaa794"},"Ultra Champagne":{"hex":"#dbcebc"},"Ultra Ivory":{"hex":"#f6f2d4"},"Ultra Curry":{"hex":"#7c5737"},"Ultra Canyon Clay":{"hex":"#5d2b1e"},"Ultra Chamois":{"hex":"#bca876"},"Ultra Citronella":{"hex":"#be9843"},"Ultra Buff":{"hex":"#bcad8c"},"Ultra Pine Cone":{"hex":"#68614e"},"Ultra Cashmere":{"hex":"#9f8a71"},"Ultra Sassy":{"hex":"#efbc61"},"Ultra Apricot":{"hex":"#be7139"},"Ultra Hide":{"hex":"#7a5331"},"Ultra Autumn Leaf":{"hex":"#a44e33"},"Ultra Milkweed":{"hex":"#ccc6ac"},"Ultra Sand":{"hex":"#cebf93"},"Ultra Almond":{"hex":"#d2c9ab"},"Ultra Taupe":{"hex":"#735c42"},"Ultra Walnut":{"hex":"#413925"},"Ultra Pecan":{"hex":"#897753"},"Ultra Cave":{"hex":"#4d473b"},"Ultra Red":{"hex":"#b44046"},"Ultra Poppy":{"hex":"#b63a2b"},"Ultra Earthenware":{"hex":"#58312b"},"Ultra Light Oyster":{"hex":"#f3ebd9"},"Ultra Poseidon":{"hex":"#495a64"},"Ultra Emerald Isle":{"hex":"#2e5049"},"Ultra Shetland":{"hex":"#535f54"},"Ultra Olive Leaf":{"hex":"#76724d"},"Ultra Sonora":{"hex":"#75845a"},"Ultra Bayou":{"hex":"#425b7a"},"Ultra Boysenberry":{"hex":"#684947"},"Ultra Cyan":{"hex":"#7299a4"},"Ultra Rain Dance":{"hex":"#4a5c63"},"Ultra Herbal Mist":{"hex":"#71877a"},"Ultra Eucalyptus":{"hex":"#768076"},"Ultra Parrot":{"hex":"#94ac5b"},"Ultra Citrus":{"hex":"#c5bf6e"},"Ultra Lagoon":{"hex":"#639fa7"},"Ultra Admiral":{"hex":"#3c424d"},"Ultra Diplomat Blue":{"hex":"#354350"},"Ultra Brick":{"hex":"#734140"},"Ultra Chianti":{"hex":"#573535"},"Ultra Garnet":{"hex":"#4f3230"},"Ultra Hot Chocolate":{"hex":"#3c302a"},"Ultra Baltic":{"hex":"#475472"},"Ultra Plum":{"hex":"#504d62"},"Ultra Nile":{"hex":"#3d4357"},"Ultra St. John":{"hex":"#547b84"},"Ultra Riviera":{"hex":"#738e9e"}};
  document.querySelectorAll('[data-linked-upholstery] .dm-upholstery__product-link').forEach(link => {
    const swatch = swatches[link.textContent.trim()];
    if (!swatch) return;
    const visual = document.createElement(swatch.image ? 'img' : 'span');
    visual.className = 'dm-upholstery__linked-swatch';
    if (swatch.image) {
      visual.src = swatch.image;
      visual.alt = '';
      visual.width = 56;
      visual.height = 44;
      visual.loading = 'lazy';
    } else {
      visual.style.backgroundColor = swatch.hex;
      visual.setAttribute('aria-hidden', 'true');
    }
    link.prepend(visual);
  });
})();
